import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function ProtectedRoute({ children }) {
  const { user } = useAuth(); // Check if user is logged in
  const location = useLocation(); // Save the current location

  if (!user) {
    // --- FIX: Redirect to /login instead of /404 ---
    // The 'state' prop saves the page they were trying to visit,
    // so you can redirect them back there after they log in.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is logged in, show the tool
  return children;
}

export default ProtectedRoute;
